<template>
  <div class="flex flex-col w-[154px] h-[192px] bg-white border-[3px] border-black-10 rounded-xl px-4 pt-8 pb-4 u-center relative">
    <OImage loading="lazy" src="/images/game/EmojileLogo.png" class="justify-start absolute -top-5 w-30 h-[46px]" />
    <div class="flex justify-between items-center self-stretch h-11">
      <div class="text-md font-medium text-[#1D1D1D] leading-5">#{{ paddedNumber }}</div>
      <div v-if="!playerStatus || playerStatus.gameStatus === 'in progress'" class="text-36 font-semibold leading-[44px] question-mark">
        ?
      </div>
      <div v-else class="text-36 font-semibold leading-[44px]">{{ playerStatus.score >= game.answer.length * 2 ? '😉' : '🥵' }}</div>
    </div>
    <div class="flex mt-2">
      <div v-for="(i, index) in game.question" :key="index" class="u-center">
        <div class="icon-border rounded-md text-20 leading-12 u-center p-4 w-8 h-8">{{ i.emoji }}</div>
        <span v-if="index < game.question.length - 1" class="text-md font-normal mx-0.5 text-[#B2C0FF]">+</span>
      </div>
    </div>
    <a
      :class="{
        'bg-[#2EB887]': !playerStatus,
        'bg-[#F3940E]': playerStatus && playerStatus.gameStatus === 'done',
        'bg-[#4D8EFF]': playerStatus && playerStatus.gameStatus === 'in progress',
      }"
      class="text-white rounded-md py-2 px-4 h-10 mt-4 self-stretch u-center text-base font-semibold"
      :href="gameUrl"
    >
      {{ playerStatus ? (playerStatus.gameStatus === 'done' ? 'Oynandı' : 'Devam Et') : 'Oyna' }}
    </a>
  </div>
</template>

<script>
import { defineComponent, computed, ref, useRoute } from '@nuxtjs/composition-api';
import dayjs from 'dayjs';
import { useAuth } from '~/modules/auth/state/useAuth';
import { localStore } from '~/modules/common/utils/localStorageUtils';
import { OImage } from '~/modules/common/components/ui';
const isToday = require('dayjs/plugin/isToday');
dayjs.extend(isToday);
export default defineComponent({
  components: { OImage },
  setup(props) {
    const { isLoggedIn } = useAuth();
    const route = useRoute();
    const isWebview = route.value?.path.includes('/mobile/oyun/');
    const playerStatus = ref(props.game.playerStatus);

    const setLocalGameData = () => {
      if (isLoggedIn.value) return;
      const data = localStore.getItem('o-emojile')?.[props.game.id];
      if (!data) return;
      const status = data.gameStatus === '' ? 'in progress' : data.gameStatus;
      playerStatus.value = { statusData: data, gameStatus: status, score: data.score };
    };

    if (process.client) {
      setLocalGameData();
    }

    const gameStatusName = computed(() => {
      if (!playerStatus.value) return 'Oyna';
      if (playerStatus.value.gameStatus === 'done') return 'Oynandı';
      if (playerStatus.value.gameStatus === 'in progress') return 'Devam Et';
    });

    const paddedNumber = computed(() => {
      return String(props.game.gameNumber).padStart(4, '0');
    });

    const gameUrl = computed(() => {
      const webviewPrefix = isWebview ? '/mobile' : '';
      const isToday = dayjs(props.game.startDate).isToday();
      return isToday ? `${webviewPrefix}/emojile` : `${webviewPrefix}/emojile?game=${props.game.id}`;
    });

    return { paddedNumber, playerStatus, gameStatusName, gameUrl };
  },
  props: {
    game: {
      type: Object,
      required: true,
    },
  },
});
</script>
<style scoped>
.icon-border {
  border: 1px solid rgba(31, 50, 119, 0.35);
  box-shadow: 0px 0px 6.982px 0px rgba(0, 0, 0, 0.05);
}

.question-mark {
  background: linear-gradient(166deg, #00084d -6.27%, #2c4389 106.87%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
